import type { ReactElement } from 'react'
import { Box } from '@mui/material'

export type ColorIndicatorProps = {
  /** Hex/CSS color shown in the swatch; renders transparent (border only) when unset. */
  color?: string
}

/** Small rounded color swatch for list rows (e.g. IFC groups, IFC type legend). */
export const ColorIndicator = ({ color }: ColorIndicatorProps): ReactElement => (
  <Box
    sx={{
      width: 24,
      height: 16,
      borderRadius: 0.5,
      backgroundColor: color ?? 'transparent',
      border: '1px solid',
      borderColor: 'divider',
      flexShrink: 0,
    }}
  />
)
